// One archive can hold several files with the same name in different folders, and an item
// can ship several archives, so only the pair identifies a file.
export const candidateKey = ({ itemFileId, entryPath }) => `${itemFileId}:${entryPath}`

export const spansSeveralArchives = candidates => new Set(candidates.map(({ itemFileId }) => itemFileId)).size > 1
